import { Conditional } from '../../../common';
import styles from './header-search-bar-suggestions-separator.module.scss';

type HeaderSearchBarSuggestionsSeparatorProps = {
  displaySeparator: boolean;
};

export const HeaderSearchBarSuggestionsSeparator = ({
  displaySeparator
}: HeaderSearchBarSuggestionsSeparatorProps) => (
  <Conditional test={displaySeparator}>
    <div
      className={`${styles['header-search-bar-suggestions-separator']} d-none d-md-block`}
      data-testid="header-searchbar-suggestion-separator"
    />
  </Conditional>
);
